<template>
  <div>
    <transition name="slide-fade" appear>
      <b-row>
        <EncabezadoDocente/>
        <b-col cols="lg-12">
          <b-card>
            <p class="text-right float-right"><strong>Año Lectivo {{ $store.state.lectivoColegio }}</strong></p>
            <h2>Horario de Clases</h2>
            <b-table small hover :items="horarioClases" :fields="titulosHorario"></b-table>
            <hr>
            <p>Actualmente no está la asignación en el horario de clases debido a que los estudiantes no están asistiendo al Colegio. Una vez se normalice el regreso a clases, se habilitarán los horarios.</p>
          </b-card>      
        </b-col>
      </b-row>
    </transition>
  </div>
</template>

<script>
  import axios from "axios"
  import * as CONFIG from '@/assets/config.js'
  import EncabezadoDocente from '@/containers/EncabezadoDocente'

  export default {
    name: 'MisTareas',
    components: {
      EncabezadoDocente
    },
    data () {
      return {
        horarioClases: [],
        titulosHorario: [
          { key: 'hora', label: 'HORA' },
          { key: 'lunes', label: 'LUNES' },
          { key: 'martes', label: 'MARTES' },
          { key: 'miercoles', label: 'MIERCOLES' },
          { key: 'jueves', label: 'JUEVES' },
          { key: 'viernes', label: 'VIERNES' },
          { key: 'sabado', label: 'SABADO' }
        ],
      }
    },
    methods: {
      cargarHorarioClases() {
        this.horarioClases = [
          { hora: '1', lunes: '-', martes: '-', miercoles: '-', jueves: '-', viernes: '-', sabado: '-'},
          { hora: '2', lunes: '-', martes: '-', miercoles: '-', jueves: '-', viernes: '-', sabado: '-'},
          { hora: '3', lunes: '-', martes: '-', miercoles: '-', jueves: '-', viernes: '-', sabado: '-'},
          { hora: '4', lunes: '-', martes: '-', miercoles: '-', jueves: '-', viernes: '-', sabado: '-'},
          { hora: '5', lunes: '-', martes: '-', miercoles: '-', jueves: '-', viernes: '-', sabado: '-'},
          { hora: '6', lunes: '-', martes: '-', miercoles: '-', jueves: '-', viernes: '-', sabado: '-'},
          { hora: '7', lunes: '-', martes: '-', miercoles: '-', jueves: '-', viernes: '-', sabado: '-'}
        ]
      },
      validarSesion() {
        if (this.$store.state.idUsuario == '' || this.$store.state.idUsuario == null) {
          this.$router.push("/pages/sesionfinalizada")
        }
      },
      mensajeEmergente(variante, titulo, contenido) {
        this.$bvToast.toast(contenido, { title: titulo, variant: variante, toaster: "b-toaster-top-center", solid: true, autoHideDelay: 4000, appendToast: false })
      }
    },
    beforeMount() {
      this.validarSesion()
      this.cargarHorarioClases()
    }
  }
</script>
